// ** Type Imports
import { Palette } from '@mui/material'
import { Skin } from 'src/@core/layouts/types'
import { hexToRGBA } from '../../utils/hex-to-rgba'

const DefaultPalette = (mode: Palette['mode'], skin: Skin): Palette => {
  // ** Vars
  const whiteColor = '#FFF'
  const lightColor = '#171717'
  const darkColor = '#171717'
  const darkPaperBgColor = '#171717'
  const hoverGrey = '#424242'
  const mainColor = mode === 'light' ? lightColor : darkColor

  const defaultBgColor = () => {
    if (skin === 'bordered' && mode === 'light') {
      return whiteColor
    } else if (skin === 'bordered' && mode === 'dark') {
      return darkPaperBgColor
    } else if (mode === 'light') {
      return '#FFFFFF'
    } else return '#25293C'
  }

  return {
    customColors: {
      dark: darkColor,
      main: mainColor,
      light: lightColor,
      lightPaperBg: whiteColor,
      darkPaperBg: darkPaperBgColor,
      bodyBg: '#FFFFFF',
      trackBg: '#F1F0F2',
      avatarBg: '#DBDADE',
      tableHeaderBg: '#FFFFFF'
    },
    mode: mode,
    common: {
      black: darkPaperBgColor,
      white: whiteColor
    },
    primary: {
      light: '#8479F2',
      main: darkPaperBgColor,
      dark: '#655BD3',
      contrastText: whiteColor
    },
    secondary: {
      light: '#B2B4B8',
      main: hoverGrey,
      dark: darkPaperBgColor,
      contrastText: whiteColor
    },
    error: {
      light: '#ED6F70',
      main: '#EA5455',
      dark: '#CE4A4B',
      contrastText: whiteColor
    },
    warning: {
      light: '#FFAB5A',
      main: '#FF9F43',
      dark: '#E08C3B',
      contrastText: whiteColor
    },
    info: {
      light: '#1FD5EB',
      main: '#00CFE8',
      dark: '#00B6CC',
      contrastText: whiteColor
    },
    success: {
      light: '#42CE80',
      main: '#28C76F',
      dark: '#23AF62',
      contrastText: whiteColor
    },
    grey: {
      50: '#FAFAFA',
      100: '#F5F5F5',
      200: '#EEEEEE',
      300: '#E0E0E0',
      400: '#BDBDBD',
      500: '#9E9E9E',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
      A100: '#F5F5F5',
      A200: '#EEEEEE',
      A400: '#BDBDBD',
      A700: '#616161'
    },
    text: {
      primary: hexToRGBA(mainColor, 1),
      secondary: hexToRGBA(mainColor, 0.68),
      disabled: hexToRGBA(mainColor, 0.42)
    },
    divider: hexToRGBA(mainColor, 0.16),
    background: {
      paper: mode === 'light' ? whiteColor : darkPaperBgColor,
      default: defaultBgColor()
    },
    action: {
      active: hexToRGBA(mainColor, 0.54),
      hover: hexToRGBA(mainColor, 0.04),
      selected: hexToRGBA(mainColor, 0.06),
      selectedOpacity: 0.06,
      disabled: hexToRGBA(mainColor, 0.26),
      disabledBackground: hexToRGBA(mainColor, 0.12),
      focus: hexToRGBA(mainColor, 0.12)
    }
  } as Palette
}

export default DefaultPalette
